import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { CashSalesResponse } from "../../../../types/sale.type";
import { COMPACT_QUERY } from "../../../../utils/hooks/useCompact";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CashSalesDetailsTabs from "./Tabs";
import DetailsDocument from "./Document";
import FooterComment from "./FooterComment";

const compact = "@media " + COMPACT_QUERY;

interface CashSalesDetailsProps {
  cashSales: CashSalesResponse;
  setTriggerFetch: Dispatch<SetStateAction<number>>;
}

export default function CashSalesDetails({
  cashSales,
  setTriggerFetch,
}: CashSalesDetailsProps) {
  const [statusTab, setStatusTab] = useState<string>("ข้อมูลเอกสาร");
  const [comment, setComment] = useState<string>("");
  const [commentLoading, setCommentLoading] = useState<boolean>(false);
  const [reqChangeLoading, setReqChangeLoading] = useState<boolean>(false);

  useEffect(() => {
    setComment(cashSales.comment || "");
  }, [cashSales.comment]);

  return (
    <>
      <CashSalesDetailsTabs statusTab={statusTab} setStatusTab={setStatusTab} />
      <Paper
        sx={{
          padding: "16px 24px",
          borderRadius: "0 12px 12px 12px",
          marginBottom: statusTab === "ข้อมูลเอกสาร" ? "0" : "36px",
        }}
      >
        {cashSales && statusTab === "ข้อมูลเอกสาร" && (
          <DetailsDocument
            cashSales={cashSales}
            setTriggerFetch={setTriggerFetch}
          />
        )}
        {statusTab === "ประวัติการทำรายการ" && <>ประวัติการทำรายการ</>}
      </Paper>
      {cashSales && statusTab === "ข้อมูลเอกสาร" && (
        <Paper
          sx={{
            padding: "16px 24px 24px",
            marginTop: "24px",
            marginBottom: "48px",
            [compact]: {
              marginTop: "16px",
            },
          }}
        >
          <Typography
            fontWeight={600}
            variant="body1"
            mb={2}
            sx={{ [compact]: { mb: 1 } }}
          >
            หมายเหตุ
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={comment}
            disabled={commentLoading}
            onChange={(e) => setComment(e.target.value)}
          />
        </Paper>
      )}
      <FooterComment
        comment={comment}
        uuid={cashSales.uuid}
        status={cashSales.status}
        replacedBy={cashSales.replaced_by}
        commentLoading={commentLoading}
        setCommentLoading={setCommentLoading}
        reqChangeLoading={reqChangeLoading}
        setReqChangeLoading={setReqChangeLoading}
        setTriggerFetch={setTriggerFetch}
      />
    </>
  );
}
